export const getPageMenuStyles = (pageMenu, { palette = {} }) => ({
  pageMenuContainer: {
    paddingTop: 7,
    width: '100%',
    backgroundColor: palette.neutralLighter,
    borderRight: `solid 1px ${palette.neutralQuaternaryAlt}`,
    position: 'absolute',
    top: 0,
    bottom: 0,
    overflowX: 'hidden',
    overflowY: 'hidden',
    '&:hover': {
      overflowY: 'auto',
    },
    '& .ms-DetailsRow-cell': {
      padding: 0,
      minWidth: 134,
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
      backgroundColor: '#C0C0C0',
    },
    '& ::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8',
    },
    '& .ms-List .ms-List-page .ms-List-cell': {
      minHeight: 1,
    },
    '& .ms-List .ms-List-page .ms-List-cell:last-child:not(:first-child)': {
      marginBottom: 8,
    },
  },
  divider: {
    width: '100%',
    borderTop: `solid 1px ${palette.neutralQuaternaryAlt}`,
    '& + div': {
      display: 'none',
    },
  },
  leftNavigationStyle: {
    paddingLeft: 5,
  },
  list: {
    backgroundColor: palette.neutralLighter,
  },
  pageMenuItem: {
    '& .page-menu-item-content': {
      fontSize: 13,
    },
    '& .page-menu-item-selected': {
      backgroundColor: palette.neutralLight,
    },
    '& .bingads-campaign-react-page-menu-item': {
      paddingRight: 0,
    },
    '& .page-menu-item-text-container': {
      marginLeft: 14,
      whiteSpace: 'normal',
    },
    '& > div': {
      width: 'unset',
      height: 'unset',
    },
  },
  pageMenuGroupHeader: {
    padding: '8.5px 0 8.5px 16px',
    fontSize: 13,
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    '& button, & .ms-Link': {
      color: palette.neutralPrimary,
      textDecoration: 'none',
      '@media screen and (forced-colors: active)': {
        color: 'canvasText',
      },
    },
    '&:hover': {
      backgroundColor: palette.neutralLight,
      textDecoration: 'none',
    },
    '&:active, & .ms-Link:active:hover': {
      backgroundColor: palette.neutralQuaternaryAlt,
      textDecoration: 'none',
    },
  },
  pageMenuSelectedGroupHeader: {
    fontWeight: 600,
  },
  pageMenuSingleItemGroupHeader: {
  },
  pageMenuGroupHeaderIcon: {
    width: 12,
    height: 22,
    marginRight: 6,
    '& i': {
      fontSize: 8,
      color: palette.neutralPrimary,
    },
  },
  pageMenuGroupHeaderContent: {
    flexBasis: '100%',
  },
  pageMenuGroupHeaderDownIcon: {
    '& i': {
      marginTop: 6,
    },
  },
  pageMenuRow: {
    backgroundColor: palette.neutralLighter,
    '& .ms-DetailsRow-cell': {
      position: 'static',
    },
  },
});
